module.exports = __webpack_public_path__ + "static/media/SV.5b070768.svg";